import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  key: 0,
  class: "tip"
}
const _hoisted_3 = {
  class: "filter-container",
  style: {"margin-top":"20px"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "action-list" }
const _hoisted_6 = { class: "dialog-footer" }

import { useRoute} from 'vue-router'
import Pagination from '@/components/Pagination.vue'
import { joinParams } from '@/utils/index'
import { useStore } from '@/store/index'
import { Modules } from '../couponline/enum'
import { getCurrentInstance, reactive, onMounted, ref, watch } from 'vue'
import { openRouteInNewWindow } from '@/utils/router-helper'
    
export default /*@__PURE__*/_defineComponent({
  __name: 'AllOrderList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const store = useStore()
    const userId = store.state.user.userInfo.id
    const route = useRoute()
    const filters = reactive({
        order_no:       '',     // 商品名称
        user_name:      '',     // 用户名称
        phone:          '',     // 用户名称
        product_name:   '',     // 券码
        type:           '',     // 类型
        pay_status:     '',     // 订单状态
        status:         '',     //订单状态
        start_time:     '',     // 开始时间
        end_time:       '',     // 结束时间
        user_coupon_id:  route.query.id || '',     // 券ID
        coupon_no:      '',     // 券码卷码
        coupon_type:   '',     // 券码类型
        page:           1,      // 当前页码
        page_size:      10,     // 每页显示条数
    })
    const state = reactive({
        refundDialog:false,
        couponDialog:false,
        couponData:[],
        data_type: '1',
    })
    const refund = reactive({
        order_id:'',
        is_untie:'',//是否解绑
        type:'',    //类型
        repund_why:'',     //换绑原因
    })
    const tableData = ref([])
    const total = ref(0)
    const activeIndex = ref(route.query.activeIndex || '1')
    const url = ref('')
    watch(() => route.query.activeIndex, (val) => { 
        activeIndex.value = val || '1'
        handleSelect(activeIndex.value, [])
    })
    const handleSelect = (key: string, keyPath: string[]) => {
        if(key == '1'){
            //调用卡券saas订单接口
            url.value = '/cake_api/orderList'
            getList()
            state.data_type = '1'
        }else{
            //调用平台订单接口
            url.value = '/coupon/orderList'
            getList()
            state.data_type = '2'
        }
    }
    // 获取列表数据
    const getList = () => {
        proxy.$http.get(url.value, filters).then(res => {
            const { code, data, msg } = res
            if (code != 200) { 
                return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
        })
    }
    //打开券码详情窗口
    const toCoupon = (id) => {
        // 找到与传入的 ID 相匹配的数据
        let matchingData = tableData.value.find((item) => item.id == id);
        // 将匹配的数据项的 coupon_info 赋值给 state.couponData
        if(matchingData.coupon_info.length>=1){
            state.couponData = matchingData.coupon_info;
            state.couponDialog = true
        }else {
            state.couponData = []
        }
        
    }
    //关闭券码详情窗口
    const couponDialogBeforeClose = () => {
        state.couponDialog = false
    }
    const toDetail = (row) => {
        //sign_type 1平台 2卡券saas
        const {id,order_no} = row
        let sign_type = ''
        if(state.data_type == '1'){
            sign_type = '2'
        }else{
            sign_type = '1'
        }

        // 应该在跳转前存入 sessionStorage，确保详情页在初始化时能正确读取到数据
        let url = `/cake_api/serviceCouponOrder?${joinParams({...filters})}`
        sessionStorage.setItem('orderList',url)

        openRouteInNewWindow({
            path: '/electron/all-order-detail',
            query: {
                order_id: id,
                order_no,
                sign_type
            }
        })
    }
    //打开券码详情窗口
    const toRefund = (row) => {
        state.refundDialog = true
        refund.order_id = row.id
        refund.type = 1

    }
    // 关闭弹框前清空数据
    const beforeDialogClose = () => {
        state.refundDialog = false
        refund.order_id = ''
        refund.type = ''
        refund.repund_why = ''
        refund.is_untie = ''
    }
    const submitRefund = () => {
        const {order_id,is_untie,repund_why} = refund
        if(!repund_why){
            return proxy.$message({type:'error',message:'请填写原因'});
        }
        if(!is_untie){
            return proxy.$message({type:'error',message:'请选择是否解绑'});
        }
        proxy.$confirm(`确定要退款吗？此退款只支持整单退款`, '提示', {
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                proxy.$http.get('/cake_api/dgssRefund',refund).then(res => {
                    if(res.code == 200){
                        proxy.$message({type:'success',message:res.msg});
                        getList();
                        beforeDialogClose()
                    }else{
                        proxy.$message({type:'error',message:res.msg});
                    }
                })
            }).catch(() => {

            })
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    // 表格行样式
    const tableRowClassName = ({ row }) => {
        if (row.is_gift === 1) {
            return 'gift-row'
        }
        return ''
    }

    onMounted(() => {
        // 根据 activeIndex 的值设置初始状态
        handleSelect(activeIndex.value, [])
        // 处理 coupon_type 参数
        if (route.query.coupon_type) {
            filters.coupon_type = route.query.coupon_type
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "default-active": activeIndex.value,
      class: "el-menu-demo",
      mode: "horizontal",
      onSelect: handleSelect
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "1" }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [
            _createTextVNode("卡券saas订单")
          ])),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "2" }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [
            _createTextVNode("平台订单")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active"]),
    (state.data_type =='2')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "标红的为赠送好友的订单，请先联系技术排查是否可退。"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.order_no,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.order_no) = $event)),
        modelModifiers: { trim: true },
        placeholder: "订单号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      (state.data_type =='1')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.user_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.user_name) = $event)),
              modelModifiers: { trim: true },
              placeholder: "用户名",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.coupon_no,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.coupon_no) = $event)),
              modelModifiers: { trim: true },
              placeholder: "电子券券码",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.product_name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.product_name) = $event)),
              modelModifiers: { trim: true },
              placeholder: "电子券名称",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_select, {
              class: "filter-item",
              filterable: "",
              modelValue: filters.type,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.type) = $event)),
              placeholder: "请选择类型",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _unref(Modules)[1],
                  value: 1
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  label: _unref(Modules)[2],
                  value: 2
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  label: _unref(Modules)[3],
                  value: 3
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_select, {
              class: "filter-item",
              modelValue: filters.pay_status,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.pay_status) = $event)),
              placeholder: "订单状态",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "未支付",
                  value: "0"
                }),
                _createVNode(_component_el_option, {
                  label: "待使用",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "已完成",
                  value: "2"
                }),
                _createVNode(_component_el_option, {
                  label: "已退单",
                  value: "3"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.phone,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.phone) = $event)),
              modelModifiers: { trim: true },
              placeholder: "手机号",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.coupon_no,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.coupon_no) = $event)),
              modelModifiers: { trim: true },
              placeholder: "券码",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.user_coupon_id,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.user_coupon_id) = $event)),
              modelModifiers: { trim: true },
              placeholder: "券ID",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_select, {
              class: "filter-item",
              modelValue: filters.status,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.status) = $event)),
              placeholder: "订单状态",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "未支付",
                  value: "0"
                }),
                _createVNode(_component_el_option, {
                  label: "已支付",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "已退款",
                  value: "2"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_select, {
              class: "filter-item",
              modelValue: filters.coupon_type,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.coupon_type) = $event)),
              placeholder: "礼券类型",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "品牌礼券",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "代金券",
                  value: "2"
                }),
                _createVNode(_component_el_option, {
                  label: "充值卡",
                  value: "3"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_time,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((filters.start_time) = $event)),
        placeholder: "开始时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_time,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((filters.end_time) = $event)),
        placeholder: "结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[13] || (_cache[13] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: "",
      "row-class-name": tableRowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "order_no",
          label: "订单号"
        }),
        (state.data_type =='1')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "user_name",
              label: "用户"
            }))
          : _createCommentVNode("", true),
        (state.data_type =='2')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "phone",
              label: "用户手机号"
            }))
          : _createCommentVNode("", true),
        (state.data_type =='1')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "product_name",
              label: "券码名称"
            }))
          : _createCommentVNode("", true),
        (state.data_type =='2')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "coupon_name",
              label: "券码名称"
            }))
          : _createCommentVNode("", true),
        (state.data_type =='2' && filters.coupon_type != '3')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 4,
              prop: "brand_name",
              label: "品牌名称 "
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.coupon_type == 3 ? '--' : row.brand_name), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (state.data_type =='2')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 5,
              label: "礼券类型"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.coupon_type == 1 ? '品牌礼券' : row.coupon_type == 2 ? '代金券' : '充值卡'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (state.data_type =='1')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 6,
              prop: "vender_name",
              label: "供应商"
            }))
          : _createCommentVNode("", true),
        (state.data_type =='1')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 7,
              prop: "type_name",
              label: "类型"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "券码信息",
          width: "260px"
        }, {
          default: _withCtx((scope) => [
            ( scope.row.coupon_info.length>=1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", null, "券码ID：" + _toDisplayString(scope.row.coupon_info[0].id), 1),
                  _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", null, "券码名称：" + _toDisplayString(scope.row.coupon_info[0].coupon_name), 1),
                  _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", null, "券码状态：" + _toDisplayString(scope.row.coupon_info[0].status), 1),
                  _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", null, "有效期：" + _toDisplayString(scope.row.coupon_info[0].valid_from) + "至" + _toDisplayString(scope.row.coupon_info[0].valid_to), 1),
                  _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                  (scope.row.coupon_info.length>=1)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "color",
                        onClick: ($event: any) => (toCoupon(scope.row.id))
                      }, "详情", 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (state.data_type =='1')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 8,
              prop: "status_name",
              label: "订单状态"
            }))
          : _createCommentVNode("", true),
        (state.data_type =='2')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 9,
              label: "订单状态"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.brand_name == '未知' && row.is_gift == 1 ? row.status + '（未领取）' : row.status), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "单价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "quantity",
          label: "数量"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_amount",
          label: "总金额"
        }),
        (state.data_type =='1')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 10,
              prop: "pay_time",
              label: "支付时间",
              width: "140"
            }))
          : _createCommentVNode("", true),
        (state.data_type =='2')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 11,
              prop: "paid_at",
              label: "支付时间",
              width: "140"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "创建时间",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "95"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (toDetail(scope.row))
              }, {
                default: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createTextVNode(" 详情 ")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (state.data_type =='2' && _unref(userId) != 330)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    disabled: scope.row.status == '已退款' || scope.row.refund_type == 1,
                    title: scope.row.status == '已退款' ? '已退款' : scope.row.refund_type == 1 ? '已部分退款' : '',
                    type: "primary",
                    class: "mt10",
                    size: "small",
                    onClick: ($event: any) => (toRefund(scope.row))
                  }, {
                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                      _createTextVNode(" 整单退款 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "title", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "券码详情信息",
      modelValue: state.couponDialog,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((state.couponDialog) = $event)),
      "before-close": couponDialogBeforeClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: state.couponData,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "券码ID"
            }),
            _createVNode(_component_el_table_column, {
              prop: "coupon_name",
              label: "券码名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "card",
              label: "卡号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "password",
              label: "密码"
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "使用状态"
            }),
            _createVNode(_component_el_table_column, {
              label: "有效期",
              width: "200px"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.valid_from) + "至" + _toDisplayString(scope.row.valid_to), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "退款",
      modelValue: state.refundDialog,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((state.refundDialog) = $event)),
      "before-close": beforeDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, { onClick: beforeDialogClose }, {
            default: _withCtx(() => _cache[30] || (_cache[30] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (submitRefund()))
          }, {
            default: _withCtx(() => _cache[31] || (_cache[31] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "form",
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "是否解绑券码",
              required: "",
              style: {"width":"450px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: refund.is_untie,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((refund.is_untie) = $event)),
                  placeholder: "是否解绑券码",
                  clearable: "",
                  style: {"width":"150px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "解绑",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "作废",
                      value: "2"
                    }),
                    _createVNode(_component_el_option, {
                      label: "不操作",
                      value: "3"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "退款原因",
              required: "",
              style: {"width":"450px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: 5,
                  maxlength: "100",
                  "show-word-limit": "",
                  modelValue: refund.repund_why,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((refund.repund_why) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})